"use strict";module.exports=function(device){var _device$nativeApp;return"iOS"===(null==device||null===(_device$nativeApp=device.nativeApp)||void 0===_device$nativeApp?void 0:_device$nativeApp.os)};
